// inspired from https://github.com/gyzerok/adrenaline/blob/master/src/network/defaultNetworkLayer.js
// import getConfig from 'next/config';
// const { serverRuntimeConfig } = getConfig();
import { setCookie } from 'utils/cookies';
import { fetch } from 'utils/http';

const DAY = 86400;

export function isClient() {
  return typeof window !== 'undefined';
}

function getCurrentAccessToken (options) {
  let access_token = options?.req?.cookies?.access_token ||
  options?.access_token || null;

  if (!access_token && isClient()) {
    const tmpTokens = sessionStorage?.getItem('tokens') || "{}";
    access_token = JSON.parse(tmpTokens)?.access_token;
  }

  return access_token;
}

export async function doQuery (query, variables/*, options = {}*/) {
  return null;
  // const endpoint = '/api/graphql';
  // // const endpoint = serverRuntimeConfig.GRAPHQL_ADDR;
  // if (Array.isArray(query)) {
  //   query = query.join('\n');
  // }

  // const opts = {
  //   method: 'post',
  //   headers: {
  //     Accept: 'application/json', //eslint-disable-line
  //     'Content-Type': 'application/json'
  //   },
  //   credentials: 'same-origin',
  //   body: JSON.stringify({
  //     query,
  //     variables
  //   })
  // };

  // const access_token = getCurrentAccessToken(options);

  // if (access_token) {
  //   opts.headers.Authorization = 'Bearer ' + access_token;
  // }

  // return fetch(endpoint, opts)
  //   .then(async (res) => {
  //     const { data } = res.json ? await res.json() : res;
  //     if (data.errors) {
  //       console.error(data.errors);
  //     }
  //     return data;
  //   })
  //   .catch((error) => {
  //     return error;
  //   });
}

export async function storeTokens (tokens) {
  return Promise.all([
    new Promise((resolve, reject) => {
      const curSessVals = JSON.parse(sessionStorage.getItem('tokens') || "{}");
      tokens.refresh_token = tokens.refresh_token || curSessVals?.refresh_token;
      sessionStorage.setItem('tokens', JSON.stringify(tokens));
      resolve();
    }),
    new Promise((resolve, reject) => {
      setCookie('access_token', tokens.access_token, {
        SameSite: 'Strict',
        'max-age': DAY
      });
      if (tokens.refresh_token) {
        setCookie('refresh_token', tokens.refresh_token, {
          'max-age': DAY * 5,
          path: '/api/login/refresh',
          SameSite: 'Strict'
        });
      }
      resolve();
    })
  ]);
}

export function fetchGQL (endpoint, options, extra) {
  const opts = {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin',
    ...options
  };

  const access_token = getCurrentAccessToken(options);

  if (access_token) {
    opts.headers.Authorization = 'Bearer ' + access_token;
  }

  return fetch(endpoint, opts)
    .then(async (result) => {
      result = result.data ? result.data : await result.json();
      return result;
    })
    .catch((err) => {
      return err;
    });
}

export function doMutation(mutation, variables, files, options = {}) {
  if (Array.isArray(mutation)) {
    mutation = mutation.join('\n');
  }
  const endpoint = "/api/graphql";

  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };

  const hasSessTokens = isClient() ? sessionStorage?.getItem('tokens') : null;
  const access_token =
    options?.req?.cookies?.access_token ||
    options?.access_token ||
    (hasSessTokens ? JSON.parse(hasSessTokens).access_token : null) ||
    null;

  if (access_token) {
    headers.Authorization = 'Bearer ' + access_token;
  }

  if (!files) {
    return fetch(endpoint, {
      method: 'post',
      headers,
      credentials: 'same-origin',
      body: JSON.stringify({
        query: mutation,
        variables
      })
    })
      .then(parseJSON)
      .then((result) => {
        if (result.errors && result.errors.length) {
          throw new Error(result.errors);
        }
        return result;
      });
  }

  const formData = new FormData();
  formData.append('query', mutation);
  formData.append('variables', JSON.stringify(variables));

  if (files) {
    for (const filename in files) {
      formData.append(filename, files[filename]);
    }
  }

  return fetch(endpoint, {
    method: 'post',
    headers,
    credentials: 'same-origin',
    body: formData
  }).then(parseJSON);
}

async function parseJSON(res) {
  const response = res?.data;
  if (response.errors) {
    console.error(response.errors);
  }
  return response?.data;
}
